module.exports = __webpack_public_path__ + "img/oyster.7def4b6f.png";